import React from "react";

function ExportIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7857 5.78564H3.64286C3.07454 5.78564 2.52949 6.01141 2.12763 6.41327C1.72576 6.81514 1.5 7.36018 1.5 7.9285V19.3571C1.5 19.9254 1.72576 20.4704 2.12763 20.8723C2.52949 21.2742 3.07454 21.4999 3.64286 21.4999H15.0714C15.6397 21.4999 16.1848 21.2742 16.5867 20.8723C16.9885 20.4704 17.2143 19.9254 17.2143 19.3571V12.2142"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.5 11.5L20.5914 2.40857M14.3571 1.5H21.5V8.64286"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ExportIcon;
